import { Injectable } from '@angular/core';

/**
 * These match the Report script library utility functions
 */
@Injectable({
  providedIn: 'root'
})
export class ReportUtilService {

  constructor() { }

  singleDataPointPercentage(options: any, elemName: any): any {
    if (options.series && options.series.length > 0) {
      let series = options.series[0];
      let data = series.data;
      if (data) {

        let sum = data.reduce(function(acc, curr) {
          return acc + curr.y;
        }, 0);

        let elem = data.find(function(e) {
          return e.name == elemName;
        });

        if (elem) {
          let percentage = sum > 0 ? (elem.y / sum) * 100 : 0;
          elem.y = Math.trunc(percentage);
          options.series[0].data = [
            elem
          ];

        }
      }
    }
    return options;
  }

  singleDataPointAggregation(options: any): any {
    // ******* IMPORTANT NOTE: Please note that this needs to replicated in the ScheduledReportService Kotlin class and transposed in JS *****
    // Special handling for aggregation fields that are special types - duration, etc
    const rsParam = options.servicely.rsParam;
    const aggregationFieldType = rsParam.AggregationFieldType;
    if (rsParam.Aggregation &&
        rsParam.AggregationFieldTable &&
        rsParam.AggregationField &&
        rsParam.Aggregation !== "count" &&
        ['duration', 'money', 'percentage'].includes(aggregationFieldType)
    ) {
      const durationDecimalPlaces = rsParam.DurationDecimalPlaces;
      let displayDecimalPlaces = (durationDecimalPlaces !== null ? parseInt(durationDecimalPlaces): 0);

      let displayValue = options.series[0].data[0].y;

      switch (aggregationFieldType) {
        case 'duration':
          displayValue = this.singleDataPointAggregationDuration(rsParam, displayValue, displayDecimalPlaces);
          break;
        case 'money':
        case 'percentage':
          displayValue = Number(displayValue).toFixed(displayDecimalPlaces);
          break;
      }

      options.series[0].data[0].y = Number(displayValue);
    }
  }

  singleDataPointAggregationDuration(rsParam: any, millis: any, displayDecimalPlaces: number): Number {
    const durationType = rsParam.DurationType;
    const durationDecimalPlaces = rsParam.DurationDecimalPlaces;
    let displayDuration = millis; // For milliseconds and none

    switch (durationType) {
      case 'seconds':
        displayDuration = Number(millis / 1000).toFixed(displayDecimalPlaces);
        break;
      case 'minutes':
        displayDuration = Number(millis / (1000 * 60)).toFixed(displayDecimalPlaces);
        break;
      case 'hours':
        displayDuration = Number(millis / (1000 * 60 * 60)).toFixed(displayDecimalPlaces);
        break;
      case 'days':
        displayDuration = Number(millis / (1000 * 60 * 60 * 24)).toFixed(displayDecimalPlaces);
        break;
      case 'weeks':
        displayDuration = Number(millis / (1000 * 60 * 60 * 24 * 7)).toFixed(displayDecimalPlaces);
        break;
      case 'months':
        displayDuration = Number(millis / (1000 * 60 * 60 * 24 * 30)).toFixed(displayDecimalPlaces);
        break;
      case 'years':
        displayDuration = Number(millis / (1000 * 60 * 60 * 24 * 365)).toFixed(displayDecimalPlaces);
        break;
    }

    return Number(displayDuration);
  }

  maxValueColourThreshold(options: any, threshold: any, colour: string): any {
    if (options.series && options.series.length > 0) {
      let series = options.series[0];
      let data = series.data;
      if (data) {
        let maxValue = data.reduce(function(acc, curr) {
          return Math.max(acc, curr.y);
        }, 0);

        if (maxValue >= threshold) {
          if (options.plotOptions.series.dataLabels && options.plotOptions.series.dataLabels.style) {
            options.plotOptions.series.dataLabels.style.color = colour;
          }
        }
      }
    }
    return options;
  }

  disableExporting(options: any): any {
    options.exporting = { enabled: false };
    return options;
  }

  disableBorder(options: any): any {
    options.servicely.className = "dynamic-portal-chart-no-border";
    return options;
  }

  setCsvOptions(options: any): any {
    options.exporting.csv = {
      "columnHeaderFormatter": null,
      "dateFormat": "%Y-%m-%d %H:%M:%S",
      "decimalPoint": null,
      "itemDelimiter": null,
      "lineDelimiter": "\n"
    }
    return options;
  }
}
